import InformationHeader from '../../../component/reusable/informationHeader/InformationHeader';
import ViewForm from '../../../component/reusable/ViewForm';

import React, { useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import api from '../../../utils/api';

const ViewLevel = () => {
  const [loading, setLoading] = useState(false)
  const [data, setData] = useState(null)

  const { id } = useParams()

  const fetchsubcategoryDetails = async () => {
      setLoading(true)
      try {
          const { data, status } = await api.viewLevel3(id)
          console.log(data?.data);

          if (status == 200) {
            setData(data?.data);
          }
      } catch (err) {
          console.log(err);
      } finally {
          setLoading(false)
      }
  }


  useEffect(() => {
      if (id) {
          fetchsubcategoryDetails()
      }
  }, [id])

  return (
    <div >
      <InformationHeader mainpage="Dashboard" prevpage="Level3"  pagename="View Level3"/>
      {loading ? <div>Please wait...</div>
        :
        <ViewForm data={data} from={'Subcategory Level3*'}/>
      }
    </div>
  );
};

export default ViewLevel;
